import React from 'react';
import CreateForm from '../../components/CreateForm/CreateForm';
import './CreatePoll.scss';

const CreatePoll = () => {
    return (
        <div className="create-poll">
                <div className="create-poll__title-container">
                    <p className="create-poll__title">Create a Poll</p>
                </div>
                <div className="create-poll__form-container">
                    <CreateForm />
                </div>
         </div>
    );
};

export default CreatePoll;